const InvestmentIcon = () => {
    return (
        <svg
            data-name="Component 80 – 13"
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="37"
            viewBox="0 0 37 37"
        >
            <g
                data-name="Ellipse 22"
                fill="var(--icon-fill-color, none)"
                stroke="var(--icon-color-outer, var(--icon-color))"
                strokeWidth="var(--icon-stroke, 0.75)"
            >
                <circle cx="18.5" cy="18.5" r="18.5" stroke="none" />
                <circle cx="18.5" cy="18.5" r="17.75" fill="none" />
            </g>
            <g data-name="Group 307" transform="translate(8 8)">
                <g
                    data-name="Ellipse 12"
                    transform="translate(6 6)"
                    fill="var(--icon-fill-color, none)"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
                    <circle cx="4.5" cy="4.5" r="3.75" fill="none" />
                </g>
                <g
                    data-name="Ellipse 13"
                    transform="translate(8 16)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
                    <circle cx="2.5" cy="2.5" r="1.75" fill="none" />
                </g>
                <g
                    data-name="Ellipse 14"
                    transform="translate(8)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
                    <circle cx="2.5" cy="2.5" r="1.75" fill="none" />
                </g>
                <g
                    data-name="Ellipse 15"
                    transform="translate(16 13) rotate(-90)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
                    <circle cx="2.5" cy="2.5" r="1.75" fill="none" />
                </g>
                <g
                    data-name="Ellipse 16"
                    transform="translate(0 13) rotate(-90)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.5" cy="2.5" r="2.5" stroke="none" />
                    <circle cx="2.5" cy="2.5" r="1.75" fill="none" />
                </g>
                <g
                    data-name="Ellipse 17"
                    transform="translate(13.083 16.311) rotate(-45)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.283" cy="2.283" r="2.283" stroke="none" />
                    <circle cx="2.283" cy="2.283" r="1.533" fill="none" />
                </g>
                <g
                    data-name="Ellipse 18"
                    transform="translate(1.461 4.689) rotate(-45)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.283" cy="2.283" r="2.283" stroke="none" />
                    <circle cx="2.283" cy="2.283" r="1.533" fill="none" />
                </g>
                <g
                    data-name="Ellipse 19"
                    transform="translate(16.31 7.918) rotate(-135)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.283" cy="2.283" r="2.283" stroke="none" />
                    <circle cx="2.283" cy="2.283" r="1.533" fill="none" />
                </g>
                <g
                    data-name="Ellipse 20"
                    transform="translate(4.69 19.539) rotate(-135)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="var(--icon-stroke, 0.75)"
                >
                    <circle cx="2.283" cy="2.283" r="2.283" stroke="none" />
                    <circle cx="2.283" cy="2.283" r="1.533" fill="none" />
                </g>
            </g>
        </svg>
    );
};

export default InvestmentIcon;
